import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import logo from './accutrans_logo.svg';
import './App.css';
import EntrySection from './components/EntrySection';
import ListSection from './components/ListSection';
import { GetUser, StartWork } from './services/api';
import { LogEntry } from './types/logEntry';
import { Project } from './types/project';


const App = (props: any) => {
    const [logEntry, setlogEntry] = useState<LogEntry>();
    const [username, setUsername] = useState<string>('');
    const [headerId, setHeaderId] = useState<number>();
    const [newProject, setNewProject] = useState<Project>();
    const [message, setMessage] = useState<any>();

    let _headerId = 0;
    let _username = '';

    const connection = new HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_BACKEND_URL}/hub`)
        .configureLogging(LogLevel.Information)
        .build();

    const start = async () => {
        try {
            await connection.start();
            console.log("SignalR Connected.");
        } catch (err) {
            console.log(err);
            setTimeout(start, 5000);
        }
    };

    connection.onclose(async () => {
        await start();
    });

    connection.on("NewLogEntry", (log: LogEntry) => {
        // Don't sync log entries that was created by the user that initially submitted it
        if(log.headerId !== _headerId)
            setlogEntry(log);
    });

    connection.on("NewProject", (project: Project) => {
        setNewProject(project);
    });

    useEffect(() => {
        start();

        GetUser().then(user => {
            _username = user.username;
            setUsername(user.username);

            StartWork(user.username).then(headerId => {
                _headerId = headerId;
                setHeaderId(headerId);
            });
        });
    }, []);

    const pushLogEntry = (log: LogEntry) => {
        setlogEntry(log);
    }

    return (
        <div>
            <Navbar style={{ backgroundColor: '#1e2943', borderBottom: '9px solid #41b6e6' }} variant="dark">
                <Navbar.Brand href="#home">
                    <img style={{ marginRight: '20px' }}
                        alt=""
                        src={logo}
                        height="30"
                        className="d-inline-block align-top" />
                    Project Log
                </Navbar.Brand>
                <Navbar.Toggle />
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <FontAwesomeIcon icon={faUser} /> {username}
                    </Navbar.Text>
                </Navbar.Collapse>
            </Navbar>
            <Container fluid>
                <Row style={{ backgroundColor: '#f1f1f1', borderBottom: '1px solid #bbbbbb' }}>
                    <Col>
                        <EntrySection headerId={headerId} pushLogEntry={pushLogEntry} username={username} />
                    </Col>
                </Row>
                <Row style={{ marginTop: '15px' }}>
                    <Col>
                        <ListSection
                            headerId={headerId}
                            logEntry={logEntry}
                            message={message}
                            newProject={newProject}
                            username={username} />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default App;
